module.exports = __webpack_public_path__ + "img/www.yelp.ca.df71a978.png";